import ACTIONS from "../../constants/actions";
import {LOCAL} from "../../constants/local";

const defaultData = {
	info     : {
		currency    : LOCAL.currency,
		email       : "",
		first_name  : "",
		id          : 0,
		last_name   : "",
		login       : "",
		middle_name : "",
		money       : 0,
		address     : "",
		birthday    : "",
		iwho        : "",
		iwhen       : "",
		passport    : ""
	},
	login    : {
		auth   : false,
		atoken : ''
	},
	cash     : {
		money   : 0,
		in_game : 0
	},
	messages : [],
	fetching : false
};

const dataFromLs = localStorage.getItem('user');
const initialState = dataFromLs ? JSON.parse(dataFromLs) : defaultData;

export default function user(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.USER.GET_INFO: {
			const out = action.data.user ?
				Object.assign({}, state, {info : action.data.user}, {fetching : false}) :
				Object.assign({}, state, {fetching : false});

			localStorage.setItem('user', JSON.stringify(out));
			return out;
		}

		case ACTIONS.USER.GET_CASH : {
			const data = {
				money   : action.data.money,
				in_game : action.data.in_game === null ? 0 : action.data.in_game
			};

			const out = Object.assign({}, state, {cash : {...data}});
			localStorage.setItem('user', JSON.stringify(out));
			return out;
		}

		case ACTIONS.USER.LOGIN: {
			const messages = action.data.hasOwnProperty('messages') ? action.data.messages : [];
			const out = Object.assign({}, state, {fetching : false, messages : messages});

			if ( messages.length === 0 ) {
				if ( action.data.auth === true ) {
					localStorage.setItem('token', action.data.atoken);
				}

				Object.assign(out, {login : action.data});
				localStorage.setItem('user', JSON.stringify(out));
			}

			return out;
		}

		case ACTIONS.USER.LOGOUT : {
			if ( state.login.auth === false ) {
				return state;
			}

			localStorage.removeItem('user');
			localStorage.removeItem('token');
			return Object.assign({}, defaultData);
		}

		case ACTIONS.USER.TOGGLE_FETCHING : {
			return Object.assign({}, state, {fetching : !state.fetching});
		}

		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/user.js